"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const DefaultVideoStreamIdSet_1 = __importDefault(require("../videostreamidset/DefaultVideoStreamIdSet"));
class NoVideoDownlinkBandwidthPolicy {
    reset() { }
    updateIndex(_videoIndex) { }
    updateMetrics(_clientMetricReport) { }
    wantsResubscribe() {
        return false;
    }
    chooseSubscriptions() {
        return new DefaultVideoStreamIdSet_1.default();
    }
}
exports.default = NoVideoDownlinkBandwidthPolicy;
//# sourceMappingURL=NoVideoDownlinkBandwidthPolicy.js.map